export default "__VITE_ASSET__DndH$Gv8__"